import { cn } from 'lib/helpers/utility';

import {
  PracticeInformationDesktop,
  PracticeInformationMobile
} from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceHeader/PracticeInformation';

import BalanceSummary from './components/BalanceSummary';
import InvoiceDetails from './components/InvoiceDetails/InvoiceDetails';
import MemoAndInfo from './components/MemoAndInfo';
import PatientInformation from './components/PatientInformation';

const InvoiceWithTokenContent = ({ invoice, invoices, amountDue, className }) => {
  return (
    <div
      className={cn('flex flex-1 flex-col overflow-y-auto', amountDue > 0 && 'mb-20', className)}>
      <PracticeInformationDesktop
        className="rounded-t-xl"
        practice={invoice?.practice}
        title={invoice?.title}
      />
      <PracticeInformationMobile
        className="min-h-fit rounded-t-xl"
        practice={invoice?.practice}
        title={invoice?.title}
      />
      {invoice?.patient && (
        <PatientInformation
          patient={invoice?.patient}
          created_at={invoice?.created_at}
          dueDate={invoice?.due_date}
          invoiceId={invoice?.id}
          hiddenFields={invoice?.hidden_fields}
        />
      )}
      <div className="flex flex-col">
        <BalanceSummary externalInvoice={invoice} invoices={invoices} amountDue={amountDue} />
        <InvoiceDetails invoice={invoice} />
        <MemoAndInfo memo={invoice?.memo} />
      </div>
    </div>
  );
};

export default InvoiceWithTokenContent;
